import purchaseTicketsPdfApi from "../../../api/pdf/purchaseTicketsPdfApi";

/**
 * 🎫 Servicio para previsualizar tickets PDF de compras.
 * GET /api/pdf/purchase-tickets/{purchaseId}
 *
 * Devuelve tanto el blob como el nombre real del archivo (si viene en el header).
 */
const PurchaseTicketPdfService = {
  view: async (
    purchaseId: number
  ): Promise<{ blob: Blob; fileName: string | null }> => {
    const response = await purchaseTicketsPdfApi.fetchBlob(`/${purchaseId}`);

    return {
      blob: response.data,
      fileName: response.fileName || null, // ✅ igual soporte para filename
    };
  },
};

export default PurchaseTicketPdfService;
